import * as crc32 from 'buffer-crc32';

const MAX_THRESHOLD = 1000;

export const isConditionalFeatureEnabled = (threshold: number, userId?: number) =>
	threshold === MAX_THRESHOLD || (userId && crc32.unsigned(String(userId).toLowerCase() as unknown as Buffer) % MAX_THRESHOLD < threshold);
